import { asyncThunkWrapper } from "../handleAsyncThunk"
import { BASEURI, headers } from "../../utils/helper"
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"

// Handle retrieve dashboard stats
export const retrieveDashboardStats = createAsyncThunk(
  "dashboard/retrieveStats",
  async (_, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "GET",
        url: `${BASEURI}/admin/dashboard/stats`,
        headers: headers()
      },
      thunkAPI,
      {
        showToast: false,
        returnDataKey: "data"
      }
    )
  }
)

const initialState = {
  stats: {
    totalSpecialists: 0,
    totalMembers: 0,
    totalForums: 0,
    totalBlogs: 0,
  },
  loading: false,
  error: null
}

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(retrieveDashboardStats.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(retrieveDashboardStats.fulfilled, (state, { payload }) => {
      state.loading = false
      if (payload) {
        state.stats = {
          ...state.stats,
          ...payload
        }
      }
    })
    builder.addCase(retrieveDashboardStats.rejected, (state, { payload }) => {
      state.loading = false
      state.error = payload
    })
  }
})

export default dashboardSlice.reducer
